var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('view-card', {
    attrs: {
      "title": "전문가 소개"
    }
  }, [_c('data-list', {
    attrs: {
      "dataList": _vm.dataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }